import React from "react";

const Shimmer = () => {
  return (
    <div className="h-[100%] overflow-y-auto decoration-none" >
      <div className="h-[10%] flex items-center border-b bg-gray-100"></div>
      <div className="h-[10%] flex items-center border-b bg-gray-100"></div>
      <div className="h-[10%] flex items-center border-b bg-gray-100"></div>
      <div className="h-[10%] flex items-center border-b bg-gray-100"></div>
      <div className="h-[10%] flex items-center border-b bg-gray-100"></div>
      <div className="h-[10%] flex items-center border-b bg-gray-100"></div>
      <div className="h-[10%] flex items-center border-b bg-gray-100"></div>
      <div className="h-[10%] flex items-center border-b bg-gray-100"></div>
      <div className="h-[10%] flex items-center border-b bg-gray-100"></div>
      <div className="h-[10%] flex items-center border-b bg-gray-100"></div>
      <div className="h-[10%] flex items-center border-b bg-gray-100"></div>
      <div className="h-[10%] flex items-center border-b bg-gray-100"></div>
    </div>
  );
};

export default Shimmer;
